import { DateFilter as AntdDateFilter } from "@empglabs/backoffice-ui-kit"

function DateFilter(props) {
  return <AntdDateFilter {...props} />
}
export default DateFilter
